import React from "react";

const MobileWarning = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "var(--color-surface-high)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        zIndex: 9999,
        textAlign: "center",
      }}
    >
      <h2 style={{ marginBottom: "1rem", color: "var(--text-primary-color)" }}>
        Mobile View Not Supported
      </h2>
      <p style={{ color: "var(--text-primary-color)" }}>
        Please open PixingAI in a larger screen for the best experience.
      </p>
    </div>
  );
};

export default MobileWarning;
